!function ($) {

  const selectors = {
    cartWrap: '.ajax-cart',
    cartItemsWrap: '.ac__sidebar-items-wrap',
    subtotal: '.ac__sidebar-subtotal span',
    addToCart: '[data-add-to-cart]',
    qntSelect: '[data-qnt-select]',
  };

  /* =======================
     INIT
  ======================= */
  function initCart() {
    fetchCart();

    $(document).on('click', selectors.addToCart, function (e) {
      e.preventDefault();
      addToCart($(this));
    });

    $(selectors.cartWrap).on('click', function (e) {
      if (
        $(e.target).hasClass('ajax-cart') ||
        $(e.target).hasClass('ac__sidebar-close')
      ) {
        closeCart();
      }
    });

    $('[data-ajax-cart-btn]').on('click', function () {
      openCart();
    });

    $('.checkout-ajax').on('click', function (e) {
      e.preventDefault();

      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: { note: $('#cart-note').val() },
        success: function () {
          window.location.href = '/checkout/';
        }
      });
    });
  }

  /* =======================
     CART FETCH
  ======================= */
  function fetchCart() {
    $.getJSON('/cart.js', function (cart) {
      $(selectors.cartItemsWrap).empty();

      if (cart.item_count === 0) {
        $('.ac__sidebar-items').addClass('hidden');
        $('.ac__sidebar-empty-cart').removeClass('hidden');
        $('.ac__sidebar-footer').addClass('hidden');
        $('[data-ajax-cart-counter]').addClass('hidden');
        return;
      }

      renderCart(cart);

      $('.ac__sidebar-footer').removeClass('hidden');
      $('.ac__sidebar-empty-cart').addClass('hidden');
      $('.ac__sidebar-items').removeClass('hidden');
      $('[data-ajax-cart-counter]').removeClass('hidden')
        .find('span').text(cart.item_count);
    });
  }

  /* =======================
     ADD TO CART
  ======================= */
  function addToCart(item) {
    const parent = item.closest('.pdp-info');
    let quantity = 1;
    let variantId = item.data('id');

    if (parent.length) {
      quantity = parent.find(selectors.qntSelect).data('qnt') || 1;

      const activeVariant = parent.find('.variant-select__dropdown span.active');
      if (activeVariant.length) {
        variantId = activeVariant.data('id');
      }
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }]
      })
    }).then(() => {
      fetchCart();
      openCart();
    });
  }

  /* =======================
     RENDER CART
  ======================= */
  function renderCart(cart) {
    $(selectors.subtotal).text(formatPrice(cart.total_price));

    cart.items.forEach(item => {
      const id = item.variant_id;

      let maxQty = 50;

      if (item.gift_card) {
        maxQty = 50;
      } else if (
        item.variant_inventory_management === 'shopify' &&
        item.variant_inventory_policy === 'deny'
      ) {
        maxQty = item.variant_inventory_quantity + item.quantity;
      }

      const bundle = item.properties?.bundleItems ? 'bundle' : '';
      const bundleItem = item.properties?.isBundleProduct;
      const hidden = bundleItem ? 'hidden' : '';

      let html = `
        <div class="ac__sidebar-item ${hidden}" data-id="${id}">
          <div class="ac__sidebar-item_img">
            <img src="${item.image}" alt="${item.title}">
          </div>

          <div class="ac__sidebar-item-wrap">
            <div class="ac__sidebar-item_title">${item.product_title}</div>
            <div class="ac__sidebar-item_variant-title">
              ${item.variant_title && !item.variant_title.includes('egular') ? item.variant_title : ''}
            </div>

            <div class="ac__sidebar-item_quantity ${bundle}">
              <div class="ac__sidebar-item_quantity-label">
                <span>${item.quantity}</span>
                <span class="arrow"></span>
              </div>
              <div class="ac__sidebar-item_quantity-dropdown">
      `;

      for (let i = 1; i <= maxQty; i++) {
        html += `
          <span class="${i === item.quantity ? 'active' : ''}"
                data-quantity="${i}">
            ${i}
          </span>`;
      }

      html += `
              </div>
            </div>
          </div>

          <div class="ac__sidebar-item_price">
            <span class="ac__sidebar-item_price-current">
              ${formatPrice(item.price * item.quantity)}
            </span>
          </div>

          <div class="ac__sidebar-item_remove ${bundle}">
            delete
          </div>
        </div>
      `;

      $(selectors.cartItemsWrap).append(html);
    });

    bindCartEvents();
    injectOrderNotes();
  }

  /* =======================
     EVENTS
  ======================= */
  function bindCartEvents() {
    $('.ac__sidebar-item_remove').off().on('click', function () {
      const id = $(this).closest('.ac__sidebar-item').data('id');
      changeItemQuantity(id, 0);
    });

    $('.ac__sidebar-item_quantity-dropdown span').off().on('click', function () {
      const id = $(this).closest('.ac__sidebar-item').data('id');
      changeItemQuantity(id, $(this).data('quantity'));
    });

    $('.ac__sidebar-item_quantity-label').off().on('click', function () {
      $(this)
        .closest('.ac__sidebar-item')
        .find('.ac__sidebar-item_quantity-dropdown')
        .toggleClass('active');
    });
  }

  /* =======================
     UPDATE CART
  ======================= */
  function changeItemQuantity(id, quantity) {
    $.post('/cart/update.js', {
      updates: { [id]: quantity }
    }, fetchCart);
  }

  /* =======================
     HELPERS
  ======================= */
  function formatPrice(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function injectOrderNotes() {
    if (!$('.cart-note').length) {
      $('<div class="cart-note"><textarea id="cart-note" rows="3" placeholder="ADD A NOTE TO YOUR ORDER"></textarea></div>')
        .insertAfter(selectors.cartItemsWrap);
    }
  }

  function openCart() {
    $(selectors.cartWrap).addClass('active');
    $('body').css('overflow', 'hidden');
  }

  function closeCart() {
    $(selectors.cartWrap).removeClass('active');
    $('body').css('overflow', 'visible');
  }

  initCart();

}(jQuery);
